import { c as _c } from "react/compiler-runtime";
import type { FileReviewDecisionGlyphChar } from '@/lib/pr-v2/file-review-decisions';
import { cn } from '@/lib/utils';
export function PrV2DecisionGlyph(t0) {
  const $ = _c(6);
  const {
    glyph: t1,
    className
  } = t0;
  const glyph = t1 === undefined ? "?" : t1;
  const t2 = glyph === "!?" && "tracking-tighter";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("inline-flex select-none items-center justify-center text-[13px] font-bold leading-none", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== glyph || $[4] !== t3) {
    t4 = <span aria-hidden="true" className={t3}>{glyph}</span>;
    $[3] = glyph;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}